import React, { useCallback } from "react";

import { useTranslation } from "@root/misc/useTranslation";

import { LineupOption } from "../../types";

import { useAthleteImgProps } from "../athleteImage";
import { useHandlePick } from "./Picker";

interface PickedOptionProps {
  option: LineupOption | undefined;
}

export const PickedOption = ({ option }: PickedOptionProps) => {
  const i18n = useTranslation();

  const athleteImgProps = useAthleteImgProps();

  const handlePick = useHandlePick();

  const onClick = useCallback(() => {
    handlePick(undefined, { clearSlot: true });
  }, [handlePick]);

  if (!option) {
    return null;
  }

  return (
    <a className="neo__lineupPicker__removeIcon" onClick={onClick}>
      <div className="neo__lineupPicker__option__playerImage">
        <img {...athleteImgProps(option)} width={40} height={40} />
      </div>
      <div className="">
        <div className="neo__lineupPicker__option__infoRow">
          <div className="neo__lineupPicker__option__infoPrice">
            <div className="neo__lineupPicker__option__infoPricePuk" />
            <span>{option.price}</span>
          </div>
          <div className="neo__lineupPicker__option__infoPosition">
            {option.position}
          </div>
        </div>
        <div className="neo__lineupPicker__option__remove">
          {i18n.t("lineup_picker.action_clear_slot")}
        </div>
      </div>
    </a>
  );
};
